(function () {
  const THRESHOLD = 500.00;
  const FREE_GIFT_VARIANT_ID = "44196679942188";
  const PRODUCT_URL = "/products/landon-tabletop-clock-1"; 

  let tooltipEl = null;
  let tooltipVisible = false;

  function createTooltip() {
    const el = document.createElement("div");
    el.id = "free-gift-tooltip";
    el.innerHTML = `
      <span id="free-gift-tooltip-close">✕</span>
      <span id="free-gift-tooltip-icon">🎁</span>
      <span id="free-gift-tooltip-text">You qualify for a free<br><strong>Landon Tabletop Clock</strong></span>
    `;
    el.style.cssText = `
      position: fixed;
      right: -320px;
      top: 50%;
      transform: translateY(-50%);
      background: #1a1a1a;
      color: #fff;
      padding: 14px 18px 14px 14px;
      border-radius: 10px 0 0 10px;
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      line-height: 1.4;
      cursor: pointer;
      z-index: 9999;
      box-shadow: -2px 2px 12px rgba(0,0,0,0.25);
      transition: right 0.4s ease;
      max-width: 280px;
      text-decoration: none;
    `;

    // Close button
    const closeBtn = el.querySelector("#free-gift-tooltip-close");
    closeBtn.style.cssText = `
      position: absolute;
      top: 6px;
      right: 8px;
      font-size: 11px;
      opacity: 0.5;
      cursor: pointer;
      line-height: 1;
    `;
    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      hideTooltip(true);
    });

    el.addEventListener("click", function () {
      window.location.href = PRODUCT_URL;
    });

    document.body.appendChild(el);
    return el;
  }

  function showTooltip() {
    if (tooltipVisible) return;
    if (!tooltipEl) tooltipEl = createTooltip();
    tooltipVisible = true;
    requestAnimationFrame(() => {
      tooltipEl.style.right = "0px";
    });
  }

  function hideTooltip(dismissed) {
    if (!tooltipVisible) return;
    tooltipVisible = false;
    tooltipEl.style.right = "-320px";
    // If user manually closed it, don't re-show this session
    if (dismissed) sessionStorage.setItem("giftTooltipDismissed", "1");
  }

  function getCartTotal(cart) {
    return cart.items.reduce((sum, item) => {
      if (item.variant_id == FREE_GIFT_VARIANT_ID) return sum;
      return sum + item.line_price / 100;
    }, 0);
  }

  async function checkCart() {
    if (sessionStorage.getItem("giftTooltipDismissed")) return;
    try {
      const cart = await (await fetch("/cart.js")).json();
      const total = getCartTotal(cart);
      const alreadyHasGift = cart.items.some(i => i.variant_id == FREE_GIFT_VARIANT_ID);

      if (total >= THRESHOLD && !alreadyHasGift) {
        console.log("triggered tooltip");
        showTooltip();
      } else {
        hideTooltip(false);
      }
    } catch (e) {
      console.error("[FreeGift]", e);
    }
  }

  // Intercept cart mutations to re-check
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url ?? "";
    if (url.includes("/cart/add") || url.includes("/cart/change") ||
        url.includes("/cart/update") || url.includes("/cart/clear")) {
      response.clone().json().then(() => setTimeout(checkCart, 300)).catch(() => {});
    }
    return response;
  };

  // Initial check on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkCart);
  } else {
    checkCart();
  }
})();